export const copyTextToClipboard = (textVal: string) => {
  const copyFrom = document.createElement('textarea')
  copyFrom.textContent = textVal
 
  const bodyElm = document.getElementsByTagName('body')[0]
  bodyElm.appendChild(copyFrom)
 
  copyFrom.select()
  const retVal = document.execCommand('copy')
  bodyElm.removeChild(copyFrom)
  return retVal
}